import React from 'react';

import Icon from './Icon';

import { Lottie } from '@crello/react-lottie';
import thanks from '../assets/animations/french/07-french.json'

export default ({ rate, onClick }) => (
  <>
    <div className="page--banner">
      <a className="page--banner--logo" href="/">
        <img alt="" src="/images/good-cup.svg" />
      </a>
      <h6>#LetsBrewBetter</h6>
    </div>
    <div className="page--header">
      <div className="page--header-index">
        <h3 className="page--header-index-title text-align--center">
          Congratulations!
        </h3>
        <p className="page--header-index-sub text-align--center">
          You just brewed a good cup.
        </p>
      </div>
    </div>
    <div className="page--body">
      <div className="page--body-thanks">
        <Lottie config={{
          animationData: thanks,
          loop: true,
        }}/>

      </div>
      <div className="page--body-rating">
        <p className="page--header-index-title text-align--center">
          How would you rate your experience?
        </p>
        <div className="page--body-rating-list">
          {[1, 2, 3, 4, 5].map((star, index) => (
            React.createElement(Icon, {
              className: rate > index ? 'icon--star icon--star-active' : 'icon--star',
              key: star,
              src: 'star',
              onClick: () => onClick('star', star),
            })
          ))}
        </div>
      </div>
    </div>
    <div className="page--footer pt0">
      <div className={rate ? 'page--footer-action' : 'page--footer-action disable'} onClick={() => onClick('rate')}>
        <span className="page--footer-button-title">
          Submit
        </span>
      </div>
    </div>
  </>
);
